import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
        setTimeout(() => {
            const sliders = document.querySelectorAll(".page-digital-highlights-single .splide");
			const tables = document.querySelectorAll(".ghm-table-wrapper")

			// Initializing Splider
			for (let i = 0; i < sliders.length; i++) {
				const slider = new Splide(sliders[i], {
					type: "slide",
					gap: "3.375rem",
					padding: '4.25rem',
					pagination: false,
					focus: 'center',
					rewind: true,
					breakpoints: {
						1023: {
							gap: "2rem",
							padding: '3.5rem',
						},
						767: {
							gap: "1.5rem",
							padding: "2rem"
						},
					}
				}).mount();

				// if(tables) {
				// 	tables.forEach(table => {
				// 		let links = table.querySelectorAll("a")
				// 		let slideImages = document.querySelectorAll(".splide__slide img")
				// 		let slideUrls = []

				// 		slideImages.forEach((image, i) => {
				// 			slideUrls[i] = image.src
				// 		})

				// 		links.forEach(link => {
				// 			link.addEventListener('click', function(e) {
				// 				e.preventDefault()
				// 				let url = e.target.href
				// 				let index = slideUrls.indexOf(url)

				// 				console.log(url)
				// 				console.log(index)
								
				// 				if( index != '-1' ) {
				// 					document.getElementById('gallery').scrollIntoView()
				// 					slider.move(index)
				// 				}
				// 			})
				// 		})
				// 	})
				// }
			}
		}, 1000)
	})